module.exports = __webpack_public_path__ + "img/meat-poultry.a9ee5183.png";